import { Stack } from 'expo-router';

import { DEFAULT_SCREEN_OPTIONS } from '../../../routing';

// ─────────────────────────────────────────────────────────────────────────────

export default function MenuDirectLinkLayout() {
  return <Stack screenOptions={DEFAULT_SCREEN_OPTIONS} />;
}
